import NotificationsMenu from "./NotificationsMenu";

export default NotificationsMenu;
